
import Desktop from './desktop'
import Mobile from './mobile'

export default

	components: { Desktop, Mobile }

	props: block: Object

